import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";
import { createTheme, useMediaQuery } from "@material-ui/core";
import { Box } from "@mui/material";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const img = imageBaseUrl + "International-Relation/IndiaPage/internship.jpg";

const InternshipOpportunities = () => {
  const points = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1600,
      },
    },
  });
  const screenFor = useMediaQuery(points.breakpoints.between("xs", "sm"));

  return (
    <Box id="internship-opportunities">
      <MainContainer
        com1={
          <ContentContainer
            Header={<Header content={"Internship Opportunities"} />}
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  <>
                    Internship provide <b>hands-on experience</b> for students
                    and freshers, bridging the gap between academic learning and
                    industry practices. Working under{" "}
                    <b> seasoned professionals </b> you refine skills, gain
                    industry insights, and expand your{" "}
                    <b>professional network.</b>
                    <br /> <br />
                    Whether in <b>finance, marketing, engineering,</b> or other
                    fields, internships help you stand out in the job market
                    with practical exposure.&nbsp;At&nbsp;<b>Taksheela,</b> we
                    guide you in finding the <b>right internship</b> that aligns
                    with your career goals, ensuring growth, learning, and
                    networking opportunities.
                  </>
                }
                textAlign={screenFor ? "left" : null}
              />
            }
          />
        }
        com2={<ImageContainer img={img} />}
      />
    </Box>
  );
};
export default InternshipOpportunities;
